export default {
    appName: "Maroxdesign",
    domain: process.env.NODE_ENV == 'production' ? 'https://www.maroxdesign.com' : 'http://127.0.0.1:8000',
    localUserKey: "maroxdesign_udt"
}
